import { Typography } from "@mui/material";

interface ErrorMessageProps {
    error: string
};

export default function ErorrMessage(props: ErrorMessageProps) {
    return <Typography sx={{color: "red"}}>{props.error}</Typography>
};